import { useQuery } from "@tanstack/react-query";
import { fetchUsersImports, UsersImportsParams, UsersImportsResponse } from "PFCore/services/users/import";
import { QueryOptions } from "PFTypes/request_options";

import { usersKeys } from "./query_keys";

export const useUsersImports = (params?: UsersImportsParams, options?: QueryOptions<UsersImportsResponse>) =>
  useQuery<UsersImportsResponse>({
    queryKey: usersKeys.imports(params),
    queryFn: () => fetchUsersImports(params),
    staleTime: 0,
    ...options
  });
